import commonApi from '@/api/_common.js'

export default {
    checkPassword(param, scb, fcb, va) {
        let reqURL = '/admin/check_password'
        commonApi.POST(reqURL, param, (data) => {
            if (scb) {
                scb(data.valid_yn, va)
            }
        }, (err) => {
            console.log('api.admin.checkPassword : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    getInfo(param, scb, fcb, va) {
        let reqURL = '/admin/info'
        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.company, data.admin_user, data.admin_user_list, data.admin_history_list, va)
            }
        }, (err) => {
            console.log('api.admin.getInfo : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    modifyInfo(param, scb, fcb, va) {
        let reqURL = '/admin/modify_info'
        commonApi.PUT(reqURL, param, () => {
            if (scb) {
                scb(va)
            }
        }, (err) => {
            console.log('api.admin.modifyInfo : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    requestSecede(param, scb, fcb, va) {
        let reqURL = '/admin/secede'
        commonApi.POST(reqURL, param, () => {
            if (scb) {
                scb(va)
            }
        }, (err) => {
            console.log('api.admin.requestSecede : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    addAdmin(param, scb, fcb, va) {
        let reqURL = '/admin/add'
        commonApi.POST(reqURL, param, () => {
            if (scb) {
                scb(va)
            }
        }, (err) => {
            console.log('api.admin.addAdmin : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    delAdmin(param, scb, fcb, va) {
        let reqURL = '/admin/del'
        commonApi.POST(reqURL, param, () => {
            if (scb) {
                scb(va)
            }
        }, (err) => {
            console.log('api.admin.delAdmin : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    giveAdmin(param, scb, fcb, va) {
        let reqURL = '/admin/give'
        commonApi.POST(reqURL, param, () => {
            if (scb) {
                scb(va)
            }
        }, (err) => {
            console.log('api.admin.giveAdmin : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    getBillDetailList(param, scb, fcb, va) {
        let reqURL = '/admin/bill_detail'

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.bill_detail_list, data.bill_addon_list, data.total_billing_amount, data.prev_bill_month, data.prev_bill_month_paid_yn, va)
            }
        }, (err) => {
            console.log('api.admin.billDetailList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    updatePassword(param, scb, fcb, va) {
        let reqURL = '/admin/change_password'
        commonApi.PUT(reqURL, param, () => {
            if (scb) {
                scb(va)
            }
        }, (err) => {
            console.log('api.admin.updatePassword : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },
    resetPassword(param, scb, fcb) {
        let reqURL = '/admin/reset_password'
        commonApi.POST(reqURL, param, () => {
            if (scb) {
                scb()
            }
        }, (err) => {
            console.log('api.admin.resetPassword : FAIL : ', err)
            if (fcb) {
                fcb(err)
            }
        })
    },
    updateRecordAccYn(param, scb, fcb) {
        let reqURL = `/admin/update_record_acc_yn/${param.admin_user_seqno}`
        commonApi.PUT(reqURL, {record_acc_yn: param.record_acc_yn}, () => {
            if (scb) {
                scb()
            }
        }, (err) => {
            console.log('api.admin.updateRecordAccYn : FAIL : ', err)
            if (fcb) {
                fcb(err)
            }
        })
    },

    getAdminHistoryList(param, scb, fcb, va) {
        let reqURL = `/admin/history_list?page_no=${param.page_no}&page_size=${param.page_size}`
        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.admin_history_list, va)
            }
        }, (err) => {
            console.log('api.admin.getAdminHistoryList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    }
}
